import { render, staticRenderFns } from "./ContactosNuevo.vue?vue&type=template&id=47de5e2e&scoped=true"
import script from "./ContactosNuevo.vue?vue&type=script&lang=js"
export * from "./ContactosNuevo.vue?vue&type=script&lang=js"
import style0 from "./ContactosNuevo.vue?vue&type=style&index=0&id=47de5e2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47de5e2e",
  null
  
)

export default component.exports